<template>
    <div class="webhook_info">
        <b-overlay :show="is_load" rounded="sm">
            <button type="button" class="btn btn-lg  waves-effect waves-themed w-100 mb-3" :class="cur_class" v-on:click="make_action">
                <span class="fal fa-check mr-1"></span>
                {{__t(butt_title)}}
            </button>
        </b-overlay>
    </div>
</template>

<script>
export default {
    name: "loyverse_webhook",
    props : {
        org : {
            type:Object
        }
    },
    data() {
        return {
            is_load: false,
        }
    },
    methods : {

        async make_action() {
            this.is_load = true;
            await pos_api.patch('/loyverse/organizations/'+ parseInt(this.org.id) + "/hook").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    EventBus.$emit("reload_org");
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                    position : "b-toaster-top-left",
                })
            });
        },
    },

    computed : {
        is_on() {
            if(this.org.hasOwnProperty("is_hook_added")) {
                return this.org.is_hook_added;
            }
        },

        cur_class () {
            if(this.is_on) {
                return "btn-danger"
            }
            return "btn-success"
        },

        butt_title() {
            if(this.is_on) {
                return "REMOVE_HOOK";
            }

            return "ADD_HOOK"
        }
    }
}
</script>

<style scoped>

</style>
